import { render, staticRenderFns } from "./payments-all-gigs.page.vue?vue&type=template&id=0fffc4c4&scoped=true&"
import script from "./payments-all-gigs.page.vue?vue&type=script&lang=js&"
export * from "./payments-all-gigs.page.vue?vue&type=script&lang=js&"
import style0 from "./payments-all-gigs.page.vue?vue&type=style&index=0&id=0fffc4c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fffc4c4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
